/**
 * Gallery photos are separate from banner and logo branding assets.
 * Strip branding URLs so they are not duplicated in gallery lists.
 */
export function sanitizeGalleryUrls(
  galleryUrls: string[] | null | undefined,
  options?: { bannerUrl?: string | null; logoUrl?: string | null }
): string[] {
  if (!galleryUrls?.length) return [];

  const exclude = new Set<string>();
  const banner = options?.bannerUrl?.trim();
  const logo = options?.logoUrl?.trim();
  if (banner) exclude.add(banner);
  if (logo) exclude.add(logo);

  if (exclude.size === 0) return [...galleryUrls];

  return galleryUrls.filter((url) => {
    const trimmed = url.trim();
    return trimmed.length > 0 && !exclude.has(trimmed);
  });
}
